import { FIELD_NAMES, USA } from '../../constants';

const ADDRESS_FIELD_NAMES = [
  FIELD_NAMES.MAILING_ADDRESS,
  FIELD_NAMES.RESIDENTIAL_ADDRESS,
];

/**
 * The value a form change should write to the store.
 *
 * Only the address fields need anything done to them: checking "I live on a
 * United States military base" hides the country picker, so the country has to
 * be filled in from the checkbox instead.
 *
 * PORT NOTE (bug fix): the class dispatched twice for every non-address field.
 * It updated the store in the non-address branch and then fell through to a
 * second, unconditional update, so each keystroke on an email, phone or
 * personal information field ran the schema update twice. Returning the value
 * to write, rather than writing it, leaves the component with a single call.
 */
export const getEditViewInputValue = ({ fieldName, value }) => {
  if (!ADDRESS_FIELD_NAMES.includes(fieldName)) {
    return value;
  }

  const newFieldValue = { ...value };

  if (newFieldValue['view:livesOnMilitaryBase']) {
    newFieldValue.countryCodeIso3 = USA.COUNTRY_ISO3_CODE;
  }

  return newFieldValue;
};
